import React from 'react';
import IconExclamation from '../../../../icons/icon-exclamation/icon-exclamation';
import { FONT_COLOR } from '../../../../fonts/font-props';
import FontBody1 from '../../../../fonts/font-body1/font-body1';
import Icon from '../../../../icons/icon/icon';
import { NOTIFICATION_LINK_TYPE } from './app-header-notification-link';

interface AppHeaderNotificationButtonProps {
    type: NOTIFICATION_LINK_TYPE;
    text: string;
    onClick: () => void;
}

const AppHeaderNotificationButton: React.FC<AppHeaderNotificationButtonProps> = ({
    type,
    text,
    onClick,
}) => {
    const iconColor = type === NOTIFICATION_LINK_TYPE.WARNING
        ? 'var(--color-accent-4)'
        : 'var(--color-accent-1)';
    const buttonClass = `header-notification-link header-notification-link--${type}`;

    return (
        <button
            type="button"
            className={buttonClass}
            onClick={onClick}
        >
            <Icon Component={IconExclamation} color={iconColor} />
            <FontBody1 color={FONT_COLOR.PRIMARY2}>{text}</FontBody1>
        </button>
    );
};

export default AppHeaderNotificationButton;
